import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import Input from '@/components/General/inputs/Input';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { saveFund } from '@/data/contributions';
import Toast from 'react-native-toast-message';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import ModalWrapper from '@/components/General/ModalWrapper';
import Toggle from '@/components/General/inputs/Toggle';
import { StyleSheet } from 'react-native-unistyles';

const AddFundScreen = () => {
    const [fundDetails, setFundDetails] = useState({});
    const { id } = useLocalSearchParams()
  
    const router = useRouter()
  
    /*** Queries ***/
    const queryClient = useQueryClient()
    const { data: fundToEdit } = Query.contributionFunds.byId({id: id, options: {enabled: !!id}})
  
    useEffect(() => {
        if(fundToEdit && id){
            setFundDetails({...fundToEdit, originalValues: fundToEdit})
        }
    }, [fundToEdit, id])
  
    const saveFundMutation = useMutation({
        mutationFn: saveFund,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: QueryKeys.contributionFunds.all()});
            router.canGoBack() ? router.back() : router.replace("/")
            setTimeout(() => Toast.show({ type: 'success', text2: `Fund ${id ? "updated" : "created"} successfully!` }), 100);
        },
        onError: () => {
            setTimeout(() => Toast.show({ type: 'error', text2: `Failed to ${id ? "update" : "create"} fund!` }), 100);
        },
    });

  return (
    <ModalWrapper title={id ? "Edit Fund" : "New Fund"} loading={saveFundMutation.isPending} onConfirm={() => {
        const payload = {
            id: fundDetails.id,
            name: fundDetails.name,
            isTaxDeductible: fundDetails.isTaxDeductible,
            isDefault: fundDetails.isDefault,
            originalValues: fundDetails.originalValues,
        };
        saveFundMutation.mutate(payload)
    }} confirmText={id ? "Update" : "Create"}>
        <Input
            isNotOnSurface
            label="Fund Name"
            value={fundDetails?.name}
            onUpdate={(new_value) => {
                setFundDetails({
                    ...fundDetails,
                    name: new_value
                })
            }}
            placeholder="e.g., General Fund"
        />
        <View style={styles.switchContainer}>
            <Text style={styles.switchLabel}>Is Tax Deductible?</Text>
        
            <Toggle
                value={fundDetails?.isTaxDeductible ?? true}
                onValueChange={(new_value) => {
                    setFundDetails({
                        ...fundDetails,
                        isTaxDeductible: new_value
                    })
                }}
            />
        </View>

        <View style={styles.switchContainer}>
            <Text style={styles.switchLabel}>Set this as the default fund</Text>
        
            <Toggle
                value={fundDetails?.isDefault}
                onValueChange={(new_value) => {
                    setFundDetails({
                        ...fundDetails,
                        isDefault: new_value
                    })
                }}
            />
        </View>
    </ModalWrapper>
  );
};

const styles = StyleSheet.create(({colors, fonts}, rt) => ({
    switchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,
        maxWidth: rt.isPortrait ? "100%" : 250

    },
    switchLabel: {
        fontSize: 14,
        fontFamily: fonts.body,
        color: colors.text
    }
})) 

export default AddFundScreen;
